import { AttributeInfo, AggregatorTotalsHandler, EmptyObject, AnyHandler } from 'src/app/types/@types/sl-v-types';
import { Aggregator, Column } from 'angular-slickgrid';
import { Type } from '@angular/core';
import { tick } from '@angular/core/testing';


export type AggName = 'count' | 'sum' | 'min' | 'max' | 'first' | 'last' | 'avg' | 'median' | 'stddev';


export interface ISLAggregator {
	init: () => void;
	accumulate: (item: any) => void;
	storeResult?: (groupTotals: any) => void;
	Accumulate: (item: any, column: Column<any>) => void;
	SetColumns: (columns: Array<Column<any>>) => void;
	AddColumn: (column: Column<any>) => void;
	RemoveColumn: (column: Column<any>) => number;
	HasColumn: (column: Column<any>) => boolean;
	GetColumns: () => Array<Column<any>>;
	SetTotals: (totals: any, completeHandler?: AggregatorTotalsHandler) => void;
	InitTotals: (totals: any) => void;
	GetAttribute: (column: Column<any>) => AttributeInfo;
	GetLabel: () => string
	GetName: () => string;
}



export class SLAggregator implements ISLAggregator, Aggregator {
	protected _name = '';
	protected _value: any;
	protected _label = '';
	protected _columns: Array<Column<any>> = [];
	protected _completed = 0;
	public groupable = true;
	public requiresInvalidation = false;
	protected requiresNumber = true;
	protected aggCount = 0;


	constructor() {
	}
	init() {

		this._completed = 0;
		this._value = {};
	}
	accumulate(item: any) {
		if (this._name === '') { return; }
		for (const column of this._columns) {
			this.Accumulate(item, column);
		}
		item = null;
	}
	Accumulate(_item: any, _column: Column<any>) {
		// override me
	}
	SetColumns(cols: Array<Column<any>>) {
		this._columns = cols;
	}
	AddColumn(column: Column<any>) {
		for (const col of this._columns) {
			if (col.id === column.id) {
				return;
			}
		}
		this._columns.push(column);
	}
	RemoveColumn(column: Column<any>): number {
		let i = -1;
		for (const col of this._columns) {
			i += 1;
			if (column.id === col.id) {
				break;
			}
		}
		if (i > -1) {
			this._columns.splice(i, 1);
		}
		this.ColumnRemoved(column);
		return this._columns.length;
	}
	HasColumn(column: Column<any>): boolean {
		for (const col of this._columns) {
			if (col.id === column.id) {
				return true;
			}
		}
		return false;
	}
	GetColumns() {
		return this._columns;
	}
	storeResult(totals: any, completeHandler?: any) {
		this.SetTotals(totals, completeHandler);
	}
	SetTotals(totals: any, _completeHandler?: AggregatorTotalsHandler) {
		this.InitTotals(totals);
		for (const column of this._columns) {
			if (this._value[column.id] === undefined) {
				continue;
			}
			if (!isNaN(this._value[column.id]) && (this.requiresNumber === true) || (this.requiresNumber === false)) {
				totals[this._name][column.id] = this._value[column.id];
			}
		}

	}
	SetAltTotals(totals, getter: AnyHandler, _completeHandler?: AggregatorTotalsHandler) {
		this.InitTotals(totals);
		for (const column of this._columns) {
			if (this._value[column.id] === undefined) {
				continue;
			}
			totals[this._name][column.id] = getter(column.id);
		}
	}
	InitTotals(totals: any) {
		totals[this._name] = {};
	}
	GetAttribute(column: Column<any>): AttributeInfo {
		if (!!column.params.attribute) {
			return column.params.attribute;
		} else {
			return null;
		}
	}
	EndAggregation(totals: any, completeHandler?: AggregatorTotalsHandler) {
		if (!!completeHandler) {
			completeHandler(totals, this._value, this.requiresInvalidation);
		}
	}
	GetLabel(): string {
		return this._label;
	}
	GetName(): string {
		return this._name;
	}
	GetTotal(): any {
		return this._value;
	}
	ColumnRemoved(_columnDef: Column<any>) {
		// override me
	}



}